import { render, staticRenderFns } from "./Create_format.vue?vue&type=template&id=2028ddcb&scoped=true"
import script from "./Create_format.vue?vue&type=script&lang=js"
export * from "./Create_format.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028ddcb",
  null
  
)

export default component.exports